import type { TTVRow } from "@/lib/types";

const A: TTVRow[] = [
{
  name: "Beta Account A-1",
  cohort: "A",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-2",
  cohort: "A",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-3",
  cohort: "A",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-4",
  cohort: "A",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-5",
  cohort: "A",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-6",
  cohort: "A",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-7",
  cohort: "A",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-8",
  cohort: "A",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-9",
  cohort: "A",
  segment: "Med",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account A-10",
  cohort: "A",
  segment: "Med",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
];

const B: TTVRow[] = [
{
  name: "Beta Account B-1",
  cohort: "B",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-2",
  cohort: "B",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-3",
  cohort: "B",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-4",
  cohort: "B",
  segment: "Mega",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-5",
  cohort: "B",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-6",
  cohort: "B",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-7",
  cohort: "B",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-8",
  cohort: "B",
  segment: "Large",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-9",
  cohort: "B",
  segment: "Med",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
{
  name: "Beta Account B-10",
  cohort: "B",
  segment: "Med",
  phase: "Closed Beta",
  ttv1: false,
  ttv2: false,
  ttv3: false,
  ttv4: false,
},
];

export const TTV_DATA = { cohortA: A, cohortB: B } as const;
